module.exports = __webpack_public_path__ + "img/blackDial.e5975d45.svg";